import { Box } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import { useFilters } from 'modules/shift_management/hooks/useFilters'
import useLocationOptions from 'modules/shift_management/hooks/useLocationOptions'

interface Props {
  locationField: Field
  setDisableSubmit: (state: boolean) => void
}
const Content = observer(({ locationField, setDisableSubmit }: Props) => {
  const { locationOptions } = useLocationOptions({ locationField })
  const [{ locationIds }] = useFilters()

  useUnsafeEffect(() => {
    if (locationIds.length === 1) {
      locationField.set(locationIds.at(0))
      setDisableSubmit(false)
    } else {
      locationField.set('')
      setDisableSubmit(true)
    }
  }, [locationIds])

  return (
    <Box gap="s16" flexDirection="row" justifyContent="center" alignItems="center">
      <TooltipIcon.Medium
        icon="pin"
        label={i18n.t('shift_management.actions_sidepanel.tooltip.workplace')}
        color="grey700"
      />
      <Box width="full">
        <DropdownSearchBar
          searchLabel={i18n.t('common.search')}
          sortLabel={i18n.t('common.name')}
          selectLabel={i18n.t('common.select')}
          labelNotFound={i18n.t('common.select')}
          label={''}
          data={locationOptions}
          name={
            locationOptions.find(
              (option) => option.value.toString() === locationField.value.toString()
            )?.label || i18n.t('common.select')
          }
          onSelect={(option) => {
            locationField.set(option.value)
            setDisableSubmit(false)
          }}
          autofocus={false}
        />
      </Box>
    </Box>
  )
})

export { Content }
